/* Velvet Vogue (28-10-2026): product gallery on phones = one big photo per view, dots underneath.
   The loop gallery writes its slide sizes as inline !important styles, so they are corrected here.
   03-11-2026: the observer now watches document.body. After a variant change the theme replaces the whole
   <media-gallery> element, and an observer on the old element never saw the new one (it kept the 76vw peek slides).
   Scheduling uses setTimeout (not requestAnimationFrame) so it also runs when the page is in a background/hidden pane. */
(function () {
  'use strict';
  var SQUARE_MIN_RATIO = 0.9;
  var queued = false;

  function setAll(el, props, value) {
    props.forEach(function (p) { el.style.setProperty(p, value, 'important'); });
  }

  function fixGallery(g) {
    var track = g.querySelector('[data-hk-loop-track]');
    if (!track) return false;
    var changed = false;

    if (track.style.getPropertyValue('gap') !== '0px') {
      track.style.setProperty('gap', '0px', 'important');
      changed = true;
    }

    g.querySelectorAll('.hk-mobile-loop-gallery__spacer').forEach(function (s) {
      if (s.style.width !== '0px') {
        s.style.setProperty('flex', '0 0 0px', 'important');
        setAll(s, ['width', 'min-width', 'max-width'], '0px');
        changed = true;
      }
    });

    g.querySelectorAll('[data-hk-loop-slide]').forEach(function (slide) {
      if (slide.style.width !== '100%') {
        slide.style.setProperty('flex', '0 0 100%', 'important');
        setAll(slide, ['width', 'min-width', 'max-width'], '100%');
        changed = true;
      }
      var media = slide.querySelector('.product-media');
      if (media) {
        var ratio = parseFloat(media.style.getPropertyValue('--ratio'));
        if (ratio) slide.classList.toggle('vv-sq', ratio >= SQUARE_MIN_RATIO);
      }
      slide.querySelectorAll('img').forEach(function (img) {
        if (img.getAttribute('sizes') !== '100vw') img.setAttribute('sizes', '100vw');
      });
    });

    return changed;
  }

  function run() {
    queued = false;
    document.querySelectorAll('hk-loop-gallery').forEach(function (g) {
      if (fixGallery(g) && typeof g.goToPhysical === 'function') {
        setTimeout(function () {
          g.goToPhysical((g.realCount > 1 ? (g.activeIndex || 0) + 1 : 0), false);
        }, 0);
      }
    });
  }

  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(run, 20);
  }

  function start() {
    run();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    window.addEventListener('pageshow', queue);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();